/**
 * [階層を持ったデータをドット区切りの文字列で検索して該当データを返す]
 * @param  {[object]} data     [検索対象のobject]
 * @param  {[string]} dotScope [.で区切られた文字列]
 * @return {[any]}             [結果]
 * @example
 */
export function getDataByDot(data, dotScope):any {
  let current = data;
  let scopes: Array<string> = dotScope.split('.');
  for(let i in scopes) {
    let _i: number = parseFloat(i);
    let scope: string = scopes[i];
    if(_i === scopes.length - 1) {
      return current[scope];
    } else {
      current = current[scope];
    }
  }
  console.error(['data not found by[ ' + dotScope + ' ] from', data]);
  return {};
}
/**
 * [
 * 階層を持った新しいデータをドット区切りの文字列から作成して返す
 * ]
 * @param  {[any]} val      [挿入されるデータ]
 * @param  {[string]} dotScope [.で区切られた文字列]
 * @return {[object]}          [階層を持ったオブジェクト]
 * @example
 *
 * val = {foo: 'foo'}
 * dotScope = 'one.two'
 * newDataFromDot(val, dotScope) // return {one: {two: {foo: 'foo'}}}
 */
export function newDataFromDot(val, dotScope): any{
  let current = {};
  let newVal = current;
  let scopes: Array<string> = dotScope.split('.');
  for(let i in scopes) {
    let _i: number = parseFloat(i);
    let scope: string = scopes[i];
    if(_i === scopes.length - 1) {
      current[scope] = val;
    } else {
      current[scope] = {};
    }
    current = current[scope];
  }
  return newVal;
}
